import { api } from 'common/util';
import React, { useEffect, useState } from 'react';

const ContentContext = React.createContext();

const ApiRoot = api.rootUrl + '/wp-json/wp/v2';

const getImage = (url, height, width) => ({ url, height, width });

const getImages = (image) => {

  const images = {
    original: getImage(image.url, image.height, image.width),
    medium: getImage(image.sizes.medium, image.sizes['medium-height'], image.sizes['medium-width']),
    medium_large: getImage(image.sizes.medium_large, image.sizes['medium_large-height'], image.sizes['medium_large-width']),
    large: getImage(image.sizes.large, image.sizes['large-height'], image.sizes['large-width']),
  }

  return images;

}

export const ContentContextProvider = ({ children }) => {

  const [state, setState] = useState({
    isLoading: true,
    clients: {},
    works: {},
    pages: {},
    menu: {},
    modal: {
      text: 'Unemployed and talented?',
      button_text: 'Send your sh** here'
    }
  });

  useEffect(() => {

    const works = {};
    const clients = {};
    const pages = {};
    const menu = {};
    const modal = {};

    fetch(ApiRoot + "/client?per_page=100")
      .then(response => response.json())
      .then(response => {

        response.forEach(item => {

          clients[item.slug] = {
            id: item.slug,
            slug: item.slug,
            title: item.title.rendered,
            logo: item.acf.logo ? item.acf.logo.url : null,
            list_element: item.acf.list_element ? item.acf.list_element : false
          }
        })

      }).then(() => fetch(ApiRoot + "/works?per_page=100"))
      .then(response => response.json())
      .then(response => {


        response.forEach(item => {

          works[item.slug] = {
            id: item.slug,
            url: item.link,
            slug: item.slug,
            title: item.title.rendered,
            image: item.acf.image ? item.acf.image.url : null,
            images: item.acf.image ? getImages(item.acf.image) : null,
            video: item.acf.video ? item.acf.video.url : null,
            video_mp4: item.acf.video_mp4 ? item.acf.video_mp4.url : null,
            client: item.acf.client ? item.acf.client.post_name : null,
            content: item.content.rendered,
            year: item.acf.date,
            area: item.acf.area,
            slideshow: item.acf.slideshow ? item.acf.slideshow : false,
            color: item.acf.color ? item.acf.color : '#FFFFFF',
            category: item.acf.category ? item.acf.category.post_title : null,
            shortDescription: {

              summaryWidth: item.acf.summary_width ? item.acf.summary_width : null,
              summaryMobileWidth: item.acf.summary_width_mobile ? item.acf.summary_width_mobile : null,
              summaryInvertedColor: item.acf.summary_inverted_color ? item.acf.summary_inverted_color : false,
              summaryBackgroundImage: item.acf.summary_background_image ? item.acf.summary_background_image : null,
              summaryBackgroundRepeat: item.acf.summary_background_image_repeat ? item.acf.summary_background_image_repeat: false,
              backgroundColor: item.acf.summary_background_color ? item.acf.summary_background_color : null,
              
              leftWidth: item.acf.left_width ? item.acf.left_width : null,
              leftMobileWidth: item.acf.left_mobile_width ? item.acf.left_mobile_width : null,
              leftImage: item.acf.left_image ? item.acf.left_image : null,
              leftVideo: item.acf.left_video ? item.acf.left_video : null,
              leftVideoMp4: item.acf.left_video_mp4 ? item.acf.left_video_mp4 : null,
              
              rightWidth: item.acf.right_width ? item.acf.right_width : null,
              rightMobileWidth: item.acf.right_mobile_width ? item.acf.right_mobile_width : null,
              rightImage: item.acf.right_image ? item.acf.right_image : null,
              rightVideo: item.acf.right_video ? item.acf.right_video : null,
              rightVideoMp4: item.acf.right_video_mp4 ? item.acf.right_video_mp4 : null,
            
            }
          }

          if (item.acf.client && clients[item.acf.client.post_name]) {

            const client = {
              id: clients[item.acf.client.post_name].id,
              name: clients[item.acf.client.post_name].title,
              logo: clients[item.acf.client.post_name].logo
            }

            works[item.slug].client = client;

          }
        });
      }).then(() => fetch(ApiRoot + "/pages"))
      .then(response => response.json())
      .then(response => {

        response.forEach(item => {

          if(item.slug === "menu") {

            menu.image = item.acf.image;
            menu.message = item.acf.message;
            menu.opacity = item.acf.image_overlay_opacity;
            modal.text = item.acf.modal_text;
            modal.button_text = item.acf.modal_button_text;

          } else {

            pages[item.slug] = {
              id: item.slug,
              slug: item.slug,
              title: item.title.rendered,
              content: item.content.rendered,
            }
  
            if (item.acf) {
              if (item.acf.left_side_text) {
                pages[item.slug].left_side_text = item.acf.left_side_text;
              }
              if (item.acf.right_side_text) {
                pages[item.slug].right_side_text = item.acf.right_side_text;
              }
            }
  
          }
        })
      }).then(() => {
        setState({ clients, works, pages, menu, modal, isLoading: false });
      });

  }, []);

  const getSlugFromPathname = (pathname) => {
    const escapedPathname = pathname.replace(/\//g, '');
    return escapedPathname === '' ? 'home' : escapedPathname;
  }

  const getPreviousWork = (slug) => {

    let keys = Object.keys(state.works);
    let index = keys.indexOf(slug);
    let previousIndex = index - 1;

    let previousSlug = keys[previousIndex];

    if (!previousSlug) {
      previousSlug = keys[keys.length - 1];
    }

    return state.works[previousSlug];

  }

  const getNextWork = (slug) => {

    let keys = Object.keys(state.works);
    let index = keys.indexOf(slug);
    let nextIndex = index + 1;

    let nextSlug = keys[nextIndex];

    if (!nextSlug) {
      nextSlug = keys[0];
    }

    return state.works[nextSlug];

  }

  const value = {
    clients: Object.keys(state.clients).map( id => state.clients[id]).filter(client => client.list_element),
    works: Object.keys(state.works).map( id => state.works[id]),
    getPageBySlug: (slug) => state.pages[getSlugFromPathname(slug)],
    slideshowWorks: Object.keys(state.works).map(id => state.works[id]).filter(work => work.slideshow),
    getWorkBySlug: (slug) => state.works[slug],
    menu: state.menu,
    modal: state.modal,
    getNextWork,
    getPreviousWork,
    isLoading: state.isLoading,
  }

  return <ContentContext.Provider value={value} >{children}</ ContentContext.Provider>
}

export const ContentContextConsumer = ContentContext.Consumer;

export default ContentContext;